/**
 * Convert from dayOfWeek index into human readable day of week 
 */
export const dayToLabel = function(dayOfWeek) {
   const daysLabel = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
   return daysLabel[dayOfWeek];
}
